import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";

interface ISafeImageProps {
  image?: IGatsbyImageData | undefined | null;
  src?: string | undefined | null;
  alt: string | undefined | null;
  style?: React.CSSProperties;
}

const SafeImage = ({ image, src, alt, style }: ISafeImageProps) => {
  if (!image && !src) return null;

  return image ? <GatsbyImage image={image} alt={alt ?? ""} style={style} /> : <img src={src ?? ""} alt={alt ?? ""} style={style} />;
};

export default SafeImage;
